function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1-Copy",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "edit-order_select-doors",
  transform: "translate(-656.000000, -376.000000)",
  fill: "#5C7284",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M661.974727,383.003091 L657.454545,378.482909 L657.454545,380.548 C657.454545,380.949818 657.129273,381.275455 656.727636,381.275455 C656.326,381.275455 656.000364,380.949818 656.000364,380.548182 L656,376.727455 C656,376.534545 656.076727,376.349455 656.213091,376.213091 C656.349455,376.076727 656.534364,376 656.727273,376 L660.548182,376.000182 C660.949818,376.000182 661.275455,376.325818 661.275455,376.727455 C661.275455,377.129091 660.949818,377.454545 660.548182,377.454545 L658.483636,377.454545 L663.003455,381.974545 C663.287455,382.258545 663.287273,382.719091 663.003273,383.003091 C662.719273,383.287091 662.258727,383.287091 661.974727,383.003091 M672,391.272727 L671.999636,387.452 C671.999636,387.050364 671.674182,386.724727 671.272545,386.724727 C670.870909,386.724727 670.545455,387.050364 670.545455,387.452182 L670.545455,389.516909 L665.948,384.919091 C665.805818,384.777091 665.619636,384.706 665.433455,384.706 C665.247455,384.706 665.061273,384.777091 664.919273,384.919091 C664.635273,385.203091 664.635273,385.663455 664.919273,385.947455 L669.516909,390.545455 L667.452,390.545455 C667.050364,390.545455 666.724727,390.871091 666.724727,391.272727 C666.724727,391.674364 667.050364,392 667.452,392 L671.272727,392 C671.465636,392 671.650545,391.923455 671.787091,391.787091 C671.923455,391.650727 672,391.465636 672,391.272727",
  id: "icon_show-nav",
  transform: "translate(664.000000, 384.000000) scale(-1, 1) rotate(-180.000000) translate(-664.000000, -384.000000) "
})));

function SvgIconShowNav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_show nav") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShowNav);
export default __webpack_public_path__ + "static/media/icon_show_nav.f0da4bf8.svg";
export { ForwardRef as ReactComponent };